var MAX_PAGINATION_SLOTS_PER_PAGE, NUM_ALLOWED_SELECTED_SLOTS, NUM_SLOTS_OUTSIDE_DOTS, getDotsAndLastPage, getFirstPageAndDots, getPageHash, getPagesByRange, getSlots, paginationFooter,
  slice = [].slice;

MAX_PAGINATION_SLOTS_PER_PAGE = 11;

NUM_SLOTS_OUTSIDE_DOTS = 2;

NUM_ALLOWED_SELECTED_SLOTS = 1;

paginationFooter = function(currentPage, reviewCount, pageSize, I18n) {
  var resultsMessage, totalPages;
  resultsMessage = I18n.p(reviewCount, 'js.modules.product_reviews.pagination.results', {
    formattedReviewCount: I18n.toNumber(reviewCount),
    startingIndex: I18n.toNumber((currentPage - 1) * pageSize + 1),
    endingIndex: I18n.toNumber(Math.min(reviewCount, pageSize * currentPage))
  });
  if (!(currentPage !== 1 || reviewCount > pageSize)) {
    return {
      resultsMessage: resultsMessage
    };
  }
  totalPages = Math.ceil(reviewCount / pageSize);
  return {
    paginationSlots: getSlots(currentPage, totalPages),
    previousPage: {
      text: I18n.t('js.modules.product_reviews.pagination.previous'),
      pageNumber: (currentPage !== 1 ? currentPage - 1 : void 0)
    },
    nextPage: {
      text: I18n.t('js.modules.product_reviews.pagination.next'),
      pageNumber: (currentPage !== totalPages ? currentPage + 1 : void 0)
    },
    resultsMessage: resultsMessage
  };
};

getSlots = function(currentPage, totalPages) {
  var endDotsThreshold, endNumber, numbersRadius, startDotsThreshold, startNumber;
  endDotsThreshold = MAX_PAGINATION_SLOTS_PER_PAGE - NUM_SLOTS_OUTSIDE_DOTS;
  startDotsThreshold = totalPages - MAX_PAGINATION_SLOTS_PER_PAGE + NUM_SLOTS_OUTSIDE_DOTS + 1;
  if (totalPages <= MAX_PAGINATION_SLOTS_PER_PAGE) {
    return getPagesByRange(1, totalPages, currentPage);
  } else if (currentPage < endDotsThreshold) {
    return slice.call(getPagesByRange(1, endDotsThreshold, currentPage)).concat(slice.call(getDotsAndLastPage(currentPage, totalPages)));
  } else if (currentPage > startDotsThreshold) {
    return slice.call(getFirstPageAndDots(currentPage)).concat(slice.call(getPagesByRange(startDotsThreshold, totalPages, currentPage)));
  } else {
    numbersRadius = (MAX_PAGINATION_SLOTS_PER_PAGE - (NUM_SLOTS_OUTSIDE_DOTS * 2) - NUM_ALLOWED_SELECTED_SLOTS) / 2;
    startNumber = currentPage - Math.floor(numbersRadius);
    endNumber = currentPage + Math.ceil(numbersRadius);
    return slice.call(getFirstPageAndDots(currentPage)).concat(slice.call(getPagesByRange(startNumber, endNumber, currentPage)), slice.call(getDotsAndLastPage(currentPage, totalPages)));
  }
};

getFirstPageAndDots = function(currentPage) {
  return [
    getPageHash(1, currentPage), {
      text: '...',
      dots: true,
      pageNumber: false
    }
  ];
};

getDotsAndLastPage = function(currentPage, totalPages) {
  return [
    {
      text: '...',
      dots: true,
      pageNumber: false
    }, getPageHash(totalPages, currentPage)
  ];
};

getPagesByRange = function(from, to, currentPage) {
  var i, pageNumber, ref, ref1, results;
  results = [];
  for (pageNumber = i = ref = from, ref1 = to; ref <= ref1 ? i <= ref1 : i >= ref1; pageNumber = ref <= ref1 ? ++i : --i) {
    results.push(getPageHash(pageNumber, currentPage));
  }
  return results;
};

getPageHash = function(pageNumber, currentPage) {
  return {
    text: pageNumber,
    pageNumber: pageNumber !== currentPage ? pageNumber : void 0
  };
};

module.exports = {
  paginationFooter: paginationFooter
};

//# sourceMappingURL=data:application/json;base64,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
